export const AUTH_USER = 'auth_user'
export const UNAUTH_USER = 'unauth_user'
export const AUTH_ERROR = 'auth_error'
export const AUTH_SUCCESS = 'auth_success'

export const LEAVE_AUTH_LOGIN_FORM = 'leave_auth_login_form'
export const REFRESH_AUTH_LOGIN_FORM = 'refresh_auth_login_form'

export const REGISTER_USER_SUCCESS = 'register_user_success'
export const REGISTER_USER_ERROR = 'register_user_error'
export const LEAVE_REGISTER_USER_FORM = 'leave_register_user_form'

export const INIT_PROFILE = 'init_profile'
export const UPDATE_PROFILE = 'update_profile'
export const UPDATE_PROFILE_SUCCESS = 'update_profile_success'
export const UPDATE_PROFILE_ERROR = 'update_profile_error'
export const LEAVE_UPDATE_PROFILE_FORM = 'leave_update_profile_form'

export const CREATE_USER = 'create_user'
export const CREATE_USER_SUCCESS = 'create_user_success'
export const CREATE_USER_ERROR = 'create_user_error'

export const INIT_USER = 'init_user'
export const UPDATE_USER = 'update_user'
export const UPDATE_USER_SUCCESS = 'update_user_success'
export const UPDATE_USER_ERROR = 'update_user_error'
export const LEAVE_USER_FORM = 'leave_user_form'

export const FETCH_USERS = 'fetch_users'
export const DELETE_USER = 'destory_user'

export const UPDATE_EVENT_TEMPLATE_CATEGORY = 'update_evebt_template_category'

export const FETCH_EVENTS = 'fetch_events'
export const SET_SELECTED_EVENT = 'set_selected_event'
export const CLEAR_SELECTED_EVENT = 'clear_selected_event'
export const FETCH_FILTERED_EVENTS = 'fetch_filtered_events'

export const INIT_EVENT_TEMPLATE = 'init_event_template'
export const UPDATE_EVENT_TEMPLATE = 'update_event_template'
export const UPDATE_EVENT_TEMPLATE_SUCCESS = 'update_event_template_success'
export const UPDATE_EVENT_TEMPLATE_ERROR = 'update_event_template_error'
export const LEAVE_EVENT_TEMPLATE_FORM = 'leave_event_template_form'

export const CREATE_EVENT_TEMPLATE = 'create_event_template'
export const CREATE_EVENT_TEMPLATE_SUCCESS = 'create_event_template_success'
export const CREATE_EVENT_TEMPLATE_ERROR = 'create_event_template_error'

export const FETCH_EVENT_TEMPLATES = 'fetch_event_templates'
export const DELETE_DEFINITION = 'destory_event_template'

export const INIT_EVENT = 'init_event'
export const EVENT_FETCHING = 'event_fetching'
export const UPDATE_EVENT_FILTER_FORM = 'update_event_filter_form'
export const LEAVE_EVENT_FILTER_FORM = 'leave_event_filter_form'
export const UPDATE_EVENT = 'update_event'
export const UPDATE_EVENTS = 'update_events'
export const TOGGLE_ASNAP = 'toggle_asnap'
export const CREATE_EVENT_ERROR = 'create_event_error'
export const UPDATE_EVENT_ERROR = 'update_event_error'
export const CLEAR_EVENT_ERROR = 'clear_event_error'

export const INIT_CRUISE = 'init_cruise'
export const UPDATE_CRUISE = 'update_cruise'
export const UPDATE_CRUISE_SUCCESS = 'update_cruise_success'
export const UPDATE_CRUISE_ERROR = 'update_cruise_error'
export const LEAVE_CRUISE_FORM = 'leave_updagte_cruise_form'
export const CREATE_CRUISE_SUCCESS = 'create_cruise_success'
export const CREATE_CRUISE_ERROR = 'create_cruise_error'
export const FETCH_CRUISES = 'fetch_cruises'

export const INIT_LOWERING = 'init_lowering'
export const UPDATE_LOWERING = 'update_lowering'
export const UPDATE_LOWERING_SUCCESS = 'update_lowering_success'
export const UPDATE_LOWERING_ERROR = 'update_lowering_error'
export const LEAVE_LOWERING_FORM = 'leave_updagte_lowering_form'
export const CREATE_LOWERING_SUCCESS = 'create_lowering_success'
export const CREATE_LOWERING_ERROR = 'create_lowering_error'
export const FETCH_LOWERINGS = 'fetch_lowerings'

export const UPDATE_AUX_DATA_STATUS = 'update_aux_data_status'
export const CLEAR_AUX_DATA_STATUS = 'clear_aux_data_status'
export const SHOW_AUX_DATA_TOAST = 'show_aux_data_toast'
